/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ZustellbesonderheitenInputs */

const de__field_zustellbesonderheiten = /** @type {(inputs: _Field_ZustellbesonderheitenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zustellbesonderheiten`)
};

/**

* @param {_Field_ZustellbesonderheitenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_zustellbesonderheiten = /** @type {((inputs?: _Field_ZustellbesonderheitenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ZustellbesonderheitenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zustellbesonderheiten(inputs)
});